import { useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'


export default function InvitationsError() {
  const error = useRouteError()

  return (
    <div className="w-full flex grow flex-col gap-4 items-start">

      <ErrorBoundary error={error} />

    </div>
  )
}
